// extracted by mini-css-extract-plugin
export default {"tupacGrid":"bm-z","tupacHeader":"cm-z","tupacHeader2":"dm-z","tupacMenu":"em-z","tupacMenu2":"fm-z","tupacMain":"gm-z","tupacMain2":"hm-z"};